import peaceCharacter from "../../../assets/images/main/article3/section1/part2/peace_character.png";

interface Props {
  className: string;
}
export function PeaceCharacter({ className }: Props) {
  return <img className={className} src={peaceCharacter} alt={"피스 캐릭터"} />;
}
